import { CompWelfareTaskRes } from '__api/zqhd/QueryTaskList';
import Mask from '__components/Mask';
import dayjs from 'dayjs';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Spacer } from 'emrn-design/Spacer';
import { Toast } from 'emrn-design/Toast';
import { isIPad } from 'emrn-design/isIPad';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { StyleSheet, View, Text, Image, ScrollView } from 'react-native';
import { EmCalendar, EmPermissions, EmContainer } from '@emcd/react-native-treasure-box/hybrid';

interface Props {
  kickOffTime?: string;
}

interface State {
  isShow: boolean;
  currentTaskData?: CompWelfareTaskRes;
  currentOnComplete?: (taskData?: CompWelfareTaskRes) => Promise<void>;
}

export class CalendarPop extends Component<Props, State> {
  private toast = React.createRef<Toast>();
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
      currentTaskData: undefined,
      currentOnComplete: undefined,
    };
  }

  // show = () => {
  //   this.setState({ isShow: true });
  // };
  show = (options?: {
    taskData?: CompWelfareTaskRes;
    onComplete?: (taskData?: CompWelfareTaskRes) => Promise<void>;
  }) => {
    this.setState({
      isShow: true,
      currentTaskData: options?.taskData,
      currentOnComplete: options?.onComplete,
    });
  };

  hide = () => {
    this.setState({ isShow: false });
  };
  handleClick = async () => {
    const { kickOffTime } = this.props;
    const time = dayjs(kickOffTime, 'YYYY-MM-DD HH:mm:ss').valueOf().toString();
    const status = (await EmPermissions.getPermissionStatus({ permission: 'calendar' })).status;
    const hasAuth = status === 'authorized';
    if (!hasAuth) {
      const data = await EmContainer.getApplicationInfo();
      this.toast.current?.show(`请先打开您手机系统设置中“${data.appName ?? '应用'}”的日历权限，才能添加到日程提醒`);
    } else {
      await EmCalendar.add({
        title: '参赛提醒：“中金所杯”初赛已开赛',
        content: '',
        startTime: time,
        endTime: time,
        remindTimes: [time],
      });
      this.toast.current?.show('已添加提醒~');
      this.hide();
      if (this.state.currentOnComplete) {
        this.state.currentOnComplete(this.state.currentTaskData);
      }
    }
  };

  render() {
    const { isShow } = this.state;
    return (
      <>
        {isShow ? (
          <Mask>
            <View style={styles.content}>
              <LinearGradient
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 0.19 }}
                colors={['#FFF7C2', '#FFFFFF']}
                style={styles.main}
              >
                <Spacer size={rpx(24)} />
                <Image
                  style={styles.ruleTitle}
                  source={require('../../images/invite/noticeTitle.png')}
                  resizeMode={'stretch'}
                />
                <Spacer size={rpx(20)} />
                <Text style={styles.text}>将初赛开赛提醒加入到日程提醒 系统将于9月22日9:30提醒参赛</Text>
                <EmTouchableOpacity
                  onPress={() => {
                    this.handleClick();
                  }}
                >
                  <Image
                    style={styles.addBtn}
                    source={require('../../images/invite/addBtn.png')}
                    resizeMode={'stretch'}
                  />
                </EmTouchableOpacity>
              </LinearGradient>
              <EmTouchableOpacity
                onPress={() => {
                  this.hide();
                }}
              >
                <Image
                  style={styles.closeImg}
                  source={require('../../images/invite/closeBtn.png')}
                  resizeMode={'stretch'}
                />
              </EmTouchableOpacity>
            </View>
            <Toast ref={this.toast} />
          </Mask>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  main: {
    width: rpx(300),
    height: rpx(200),
    backgroundColor: '#fff',
    borderRadius: rpx(32),
    alignItems: 'center',
    paddingHorizontal: rpx(40),
    paddingBottom: rpx(20),
  },
  text: {
    fontSize: rpx(15),
    color: '#333333',
    lineHeight: rpx(24),
    textAlign: 'justify',
    textAlignVertical: 'center',
  },
  ruleTitle: {
    width: rpx(93.5),
    height: rpx(21.5),
  },
  addBtn: {
    width: rpx(211),
    height: rpx(41),
    marginTop: rpx(20),
  },
  Tittext: {
    fontSize: rpx(20),
    color: '#3A5DD7',
    fontWeight: 'bold',
  },
  closeImg: {
    marginTop: rpx(20),
    width: rpx(56),
    height: rpx(41),
  },
});
